"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.directoryPicker.selectDirectory': 'Select Directory from Google Drive',
    'googleDrive.directoryPicker.title': 'Select Google Drive Directory',
    'googleDrive.directoryPicker.loading': 'Loading directories...',
    'googleDrive.directoryPicker.selectInstruction': 'Click on a directory to select it for bulk knowledge upload:',
    'googleDrive.directoryPicker.lastModified': 'Last Modified',
    'googleDrive.directoryPicker.noFolders': 'No Folders Found',
    'googleDrive.directoryPicker.noFoldersDescription': 'No directories were found in your Google Drive.',
    'googleDrive.directoryPicker.directorySelected': 'Directory selected',
    'googleDrive.directoryPicker.directoryCleared': 'Directory selection cleared',
    'googleDrive.directoryPicker.loadError': 'Failed to load Google Drive directories',
    'googleDrive.directoryPicker.selected': 'Selected',
};
